module.exports = __webpack_public_path__ + "static/media/bebe2.c8a916ca.jpg";